import moment from 'moment';

/**
 * 桁区切りを入れた数値を返す
 * @param {Number, String} n 数値
 * @returns {String} 桁区切りを含めた数値の文字列
 */
const separateCharacterNumber = (n) => {
  const number = parseInt(n, 10);
  if (number) {
    return number.toLocaleString();
  }
  return '0';
};

// TODO: Setを使うように修正（パフォーマンス改善）
/**
 * 配列からUniqueなものを取り出す
 * @param {Array} Array
 * @returns {Array} 重複を取り除いた配列
 */
const getUniqueValues = ([...array]) => (
  array.filter((value, index, self) => self.indexOf(value) === self.lastIndexOf(value))
);

/**
 * YYYY-MM-DDの文字列をYYYY/MM/DDに変換して返す
 * @param {String} date YYYY-MM-DD
 * @returns {String} date YYYY/MM/DD
 */
const formatDate = (date) => {
  if (date) {
    return date.replace(/-/g, '/');
  }
  return null;
};

const formatForDatePicker = (date) => {
  if (date && date !== '') {
    return moment(date).format('YYYY-MM-DD');
  }
  return '';
};

/**
 * HH:mmの形式の2つの時間文字列から、差分の時間計算しをHH:mm形式で返す
 * @param {String} startTime 開始時間(HH:mm)
 * @param {String} endTime 終了時間(HH:mm)
 * @returna {String} diffTime 差分時間(HH:mm)
 */
const calcDiffTime = (startTime, endTime) => {
  const [sHour, sTime] = startTime.split(':');
  const [eHour, eTime] = endTime.split(':');
  const diffHour = parseInt(eHour, 10) - parseInt(sHour, 10);
  const diffTime = parseInt(eTime, 10) - parseInt(sTime, 10);
  const diffTimeTotal = diffHour * 60 + diffTime;
  if (Number.isNaN(diffTimeTotal) || diffTimeTotal < 0) {
    return '';
  }
  const fixedDiffHour = `00${Math.trunc(diffTimeTotal / 60)}`.slice(-2);
  const fixedDiffTime = `00${diffTimeTotal % 60}`.slice(-2);
  return `${fixedDiffHour}:${fixedDiffTime}`;
};

/**
 * HH:mm形式で記された時間の配列から合計時間を計算し返す
 * @param {Array} timeArray 時間の配列（HH:mm)
 * @returns {String} totalTime 合計時間（HH:mm）
 */
const calcTotalTime = (timeArray) => {
  const totalMinutes = timeArray.reduce((acc, cur) => {
    if (cur === '') {
      return acc;
    }
    const [hour, time] = cur.split(':');
    // eslint-disable-next-line no-param-reassign
    acc += parseInt(hour, 10) * 60 + parseInt(time, 10);
    return acc;
  }, 0);
  let totalHour = Math.trunc(totalMinutes / 60);
  if (String(totalHour).length < 3) {
    totalHour = `00${totalHour}`.slice(-2);
  }
  const totalTime = `00${totalMinutes % 60}`.slice(-2);
  return `${totalHour}:${totalTime}`;
};

/**
 * 開始年と終了年から年月のリスト作成し返す
 * @param {Number} startYear 開始年（西暦）
 * @param {Number} endYear 終了年（西暦）
 * @returns {Array} termList 年月のリスト
 * ex: termList = [
 *  {
 *    year: 2020,
 *    months: [01, 02, 03, 04, 05, 06, 07, 08, 09]
 *  },
 *  {
 *    year: 2019,
 *    months: [01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12]
 *  },
 *  {
 *    year: 2018,
 *    months: [01, 02, 03, 04, 05, 06, 07, 08, 09, 10, 11, 12]
 *  },
 * ]
 */
const calcYearMonthTermList = (startYear, endYear = parseInt(moment().format('YYYY'), 10)) => {
  // const endYear = moment().format('YYYY');
  const yearTerm = [];
  for (let year = endYear; startYear <= year; year -= 1) {
    yearTerm.push(year);
  }
  const currentMonth = moment().format('MM');
  const monthAll = [...Array(12)].map((_, index) => `0${index + 1}`.slice(-2), []);
  const termList = yearTerm.reduce((acc, cur) => {
    if (cur === endYear) {
      acc.push({
        year: String(cur),
        months: monthAll.slice(0, currentMonth),
      });
      return acc;
    }
    acc.push({
      year: String(cur),
      months: monthAll,
    });
    return acc;
  }, []);
  return termList;
};

/**
 * 月末を返す
 * @param {String} date 年月 YYYY-MM-DD
 */
const endOfMonth = (date) => {
  const resultDate = moment(date).endOf('month').format('YYYY-MM-DD');
  return resultDate;
};

/**
 * 指定した${addMonth}ヶ月を計算して返す
 * @param {String} date 年月 YYYY-MM-DD
 */
const calcMonth = (date, addMonth, { isEnd } = { isEnd: false }) => {
  let resultDate = moment(date).add(addMonth, 'months').format('YYYY-MM-DD');
  if (isEnd) {
    resultDate = endOfMonth(resultDate);
  }
  return resultDate;
};

/**
 * 指定したdomの下部までwindowをスクロールさせる
 */
const scrollYToDom = (dom) => {
  const { offsetTop, offsetHeight } = dom;
  window.scrollTo({
    left: 0,
    top: offsetTop + offsetHeight,
    behavior: 'smooth',
  });
};

export {
  separateCharacterNumber,
  getUniqueValues,
  formatDate,
  formatForDatePicker,
  calcDiffTime,
  calcTotalTime,
  calcYearMonthTermList,
  calcMonth,
  scrollYToDom,
};
